import { Box, Typography, Card, Button } from '@bharatpe/bharat-ui';
import React, { useState } from 'react';
import TopArrow from 'assets/icons/Autopay/topArrow.svg';
import BottomArrow from 'assets/icons/Autopay/bottomRow.svg';

interface Props {
	toggleFeature?: boolean;
	toggleAction?: () => void;
	buttonName?: string;
	icon: string;
	primaryTitle: string;
	primaryDesc?: string;
	secondaryTitle: string;
	secondaryDesc?: string;
	buttonClick?: () => void;
}

const ToggleCard: React.FC<Props> = ({
	toggleFeature,
	toggleAction,
	buttonName,
	primaryTitle,
	primaryDesc,
	secondaryTitle,
	secondaryDesc,
	icon,
	buttonClick,
}) => {
	const [toggle, setToggle] = useState<boolean>(false);

	const onToggleClick = () => {
		toggleAction && toggleAction();
		setToggle(!toggle);
	};
	return (
		<Card className="flex flex-column m4 p4">
			<Box className="flex flex-row">
				<div className="content-center mb4 w-10">
					<img src={icon} width={32} height={32} />
				</div>
				<div className="flex flex-column w-66 mx4">
					<Typography className="SemiBold200">{primaryTitle || ' '} </Typography>
					<Typography className="Regular200 grey-dark">{primaryDesc || ' '} </Typography>
				</div>
				{!toggleFeature ? (
					<div className="secondary-background content-center button-card w-25">
						<Button
							variant="text"
							onClick={
								buttonClick
									? buttonClick
									: () => {
											console.log('do nothing');
									  }
							}>
							{buttonName}
						</Button>
					</div>
				) : (
					<Box className="content-center button-card w-25 ml5" onClick={() => onToggleClick()}>
						<img src={toggle ? TopArrow : BottomArrow} width={18} height={18} className="ml5" />
					</Box>
				)}
			</Box>
			{toggleFeature && !toggle && (
				<Box>
					<Box className="horizontal-divider my4" />
					<Box className="flex flex-column">
						<Typography className="SemiBold200 mb3"> {secondaryTitle} </Typography>
						<Typography className="Light100 grey-dark">{secondaryDesc || ' '}</Typography>
					</Box>
				</Box>
			)}
		</Card>
	);
};

export default ToggleCard;
